;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	//TODO: add errors handler
	//TODO: add validation
	View.ContactUs = Marionette.ItemView.extend({
		tagName: 'div',
		initialize: function() {
			//this.model = this.getOption('model');
			this.form = this.getOption('form');
			this.user = this.getOption('user');
			var client_message = this.model.get('client_message');
			if (client_message) {
				this.form.fields.client_message = client_message;
			}

			if(this.user.id !== 0) {
				this.form.fields.name.editor.value = this.user.first_name + ' ' + this.user.last_name;
				this.form.fields.email.editor.value = this.user.email;

				this.form.setValue({
					name: this.user.first_name + ' ' + this.user.last_name,
					email: this.user.email
				});
			}
		},

		ui: {
			contactUsSubmit: '#js-contact-us-submit',
			form:            '#js-contact-us-form'
		},

		events: {
			'submit @ui.form':           'contact',
			'click @ui.contactUsSubmit': 'contact'
		},

		render: function() {
			this.$el.html(this.form.render().el);
			return this;
		},

		validate: function() {
			var errs = this.form.validate();
			if (errs) event.preventDefault();
		},

		contact: function(event) {
			event.preventDefault();

			this.validate();


			this.model.save(this.form.getValue(), {
				success: (model, response) => {
					if (response.success) {
						APP.vent.trigger('popup:message:show', 'Thank you. Your email has been sent.');
						this.render()
					}
				}
			});

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));